const prepareCatalogueFilters = ({
  subcategoryIds,
  continuousIds,
  categoryIds,
  collectionIds,
  colorIds,
  sizeIds,
  fittingIds,
  closureIds,
  hoodIds,
  paddingIds,
  pocketsIds,
  reversibleIds,
  sleevesIds,
}) => {
  let filters = [];
  if (subcategoryIds && subcategoryIds.length > 0) {
    filters.push({
      Field: "SubcategoryId",
      Operator: "In",
      Value: String(subcategoryIds),
      FilterType: "System.String",
    });
  }
  if (continuousIds && continuousIds.length > 0) {
    filters.push({
      Field: "continuos",
      Operator: "In",
      Value: String(continuousIds),
      FilterType: "System.String",
    });
  }
  if (categoryIds && categoryIds.length > 0) {
    filters.push({
      Field: "CategoryId",
      Operator: "In",
      Value: String(categoryIds),
      FilterType: "System.String",
    });
  }
  if (collectionIds && collectionIds.length > 0) {
    filters.push({
      Field: "CollectionId",
      Operator: "In",
      Value: String(collectionIds),
      FilterType: "System.String",
    });
  }
  if (colorIds && colorIds.length > 0) {
    filters.push({
      Field: "ColorId",
      Operator: "In",
      Value: String(colorIds),
      FilterType: "System.String",
    });
  }
  if (sizeIds && sizeIds.length > 0) {
    filters.push({
      Field: "SizeId",
      Operator: "In",
      Value: String(sizeIds),
      FilterType: "System.String",
    });
  }
  if (fittingIds && fittingIds.length > 0) {
    filters.push({
      Field: "FittingId",
      Operator: "In",
      Value: String(fittingIds),
      FilterType: "System.String",
    });
  }

  if (closureIds && closureIds.length > 0) {
    filters.push({
      Field: "ClosureId",
      Operator: "In",
      Value: String(closureIds),
      FilterType: "System.String",
    });
  }

  if (hoodIds && hoodIds.length > 0) {
    filters.push({
      Field: "HoodId",
      Operator: "In",
      Value: String(hoodIds),
      FilterType: "System.String",
    });
  }

  if (paddingIds && paddingIds.length > 0) {
    filters.push({
      Field: "PaddingId",
      Operator: "In",
      Value: String(paddingIds),
      FilterType: "System.String",
    });
  }

  if (pocketsIds && pocketsIds.length > 0) {
    filters.push({
      Field: "PocketsId",
      Operator: "In",
      Value: String(pocketsIds),
      FilterType: "System.String",
    });
  }

  if (reversibleIds && reversibleIds.length > 0) {
    filters.push({
      Field: "ReversibleId",
      Operator: "In",
      Value: String(reversibleIds),
      FilterType: "System.String",
    });
  }

  if (sleevesIds && sleevesIds.length > 0) {
    filters.push({
      Field: "SleevesId",
      Operator: "In",
      Value: String(sleevesIds),
      FilterType: "System.String",
    });
  }
  return filters;
};

export default prepareCatalogueFilters;
